import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueResource from "vue-resource";
import './assets/style.css'
import 'leaflet/dist/leaflet.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'jquery/src/jquery.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import { translateFunc } from './common/Filters';
import { formatAddress } from './common/HelperFunctions';
import { langFileVersion } from "./common/Constant"

import 'vue-phone-number-input/dist/vue-phone-number-input.css';

let langVersion = langFileVersion
if(localStorage.language && langFileVersion){  
  window.selectedLang = require(`../public/locales/${localStorage.language + langVersion}.json`);
} else {
  window.selectedLang = require(`../public/locales/dk${langVersion}.json`);
}
window.ukLang = require(`../public/locales/uk${langVersion}.json`);

Vue.filter("translate", translateFunc);
Vue.filter("formatAddress", formatAddress);

Vue.config.productionTip = false

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// For api calling
Vue.use(VueResource);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
